import { StudentDto } from '@mse-reg/clients';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// State
const initialState = {
  tabs: [] as StudentDto[],
  selectedTab: null as StudentDto,
};

export type StudentTabsState = Readonly<typeof initialState>;

// Slice
const studentTabsSlice = createSlice({
  name: 'studentTabs',
  initialState,
  reducers: {
    addTab(state, action: PayloadAction<StudentDto>) {
      state.tabs.push(action.payload);
    },
    removeTab(state, action: PayloadAction<StudentDto>) {
      state.tabs = state.tabs.filter((t) => t.id !== action.payload?.id);
      state.selectedTab = null;
    },
    selectStudent(state, action: PayloadAction<StudentDto>) {
      const student = action.payload;
      if (student && !state.tabs.find((t) => t.id === student.id)) {
        state.tabs.push(student);
      }
      state.selectedTab = student;
    },
    closeAllTabs(state) {
      state.tabs = [];
    },
  },
});

export const studentTabsReducer = studentTabsSlice.reducer;
export const studentTabsActions = studentTabsSlice.actions;

// Legacy module pattern for backward compatibility
const initActions = (componentDispatch: any) => {
  return Object.freeze({
    selectStudent: (student: StudentDto): void => componentDispatch(studentTabsSlice.actions.selectStudent(student)),
    removeTab: (student: StudentDto): void => componentDispatch(studentTabsSlice.actions.removeTab(student)),
    addTab: (student: StudentDto): void => componentDispatch(studentTabsSlice.actions.addTab(student)),
    closeAllTabs: (): void => componentDispatch(studentTabsSlice.actions.closeAllTabs()),
  });
};

export type StudentTabActions = ReturnType<typeof initActions>;

export const studentTabsModule = {
  initActions: (dispatch) => initActions(dispatch),
  reducer: studentTabsSlice.reducer,
};
